<template>
  <div class="tab-text" id="deposit_form_crypto">

    <vs-alert class="my-3" color="warning" :active="coin.network.length <= 0" icon-pack="feather" icon="icon-alert-circle">
      {{$t('There is no possibility of deposit and withdrawal in increasing and decreasing currencies!')}}
    </vs-alert>

    <p v-if="coin.network.length > 0">{{$t('To deposit to a usable wallet, use the following wallet address. After depositing the effect, register the transaction in the box below within two hours of Txid.')}}</p>
    <div class="vx-row mb-base">
      <div class="w-full" :class="coin.network.length > 0?'lg:w-1/3':''">
        <div class="lg:mt-12 mt-5">
          <div class="text-center lg:pt-5">
            <i class="font-large-6 mt-5 cf" v-if="isFontExist(coin.symbol)" :class="'cf-'+coin.symbol.toLowerCase()" :style="{color:colorSymbol(coin.symbol)}"></i>
            <img :src="publicPath+'images/currency/' + iconSymbol(coin.symbol)" width="100px" class="mx-auto" v-else />
          </div>
          <div class="items-center mt-3">
            <h4 class="text-center">
              موجودی {{getNameCoin(coin.symbol)[islocale]}}:
              {{toFixFloat(coin.balance)}} {{coin.symbol}}
            </h4>
          </div>
          <p class="text-center mt-2">
            {{$t('Equivalent')}}:
            {{(coin.balance * coin.fee_toman).toLocaleString('en-US') }} {{$t('Toman')}}
          </p>
        </div>
      </div>

      <div class="lg:w-2/3 w-full relative" :id="'address_wallet_'+coin.name" >
        <vs-tabs color="warning" class="tab-action-btn-fill-conatinermt-base mt-5 ld:mt-0" v-if="coin.network.length > 0"  v-model="activeTab">
          <vs-tab class="" :label=" $t('network')+' '+ (item.name)" v-for="(item,index) in coin.network" v-if="item.status">
            <div class="tab-text border-3 border-solid text-center py-2">
              <img class="mx-1 mt-2 mx-auto cursor-pointer" :src="coin.address_wallet[item.symbol].qrImage" width="100px"
                   @click="popupImgaeSrc=coin.address_wallet[item.symbol].qrImage;popupImage=true">

              <h2 class="mt-4 lg:text-2xl text-sm text-break" style="word-break: break-all;" v-if="coin.address_wallet[item.symbol].addressId">
                {{coin.address_wallet[item.symbol].addressId}}
              </h2>
              <h2 v-else class="py-3">{{$t('The deposit is temporarily closed')}}</h2>

              <h2 class="mt-4 lg:text-2xl text-sm text-break" style="word-break: break-all;" v-if=" tag = coin.address_wallet[item.symbol].addressTag">
                Tag: {{tag}}
              </h2>
              <div class="flex" v-if="coin.address_wallet[item.symbol].addressId">
                <vs-button class="mt-2" :class="tag?'ml-auto mr-1':'mx-auto'" size="small" icon-pack="feather" icon="icon-copy"
                           v-clipboard:copy="coin.address_wallet[item.symbol].addressId"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">
                  {{$t('Copy َAddress')}}
                </vs-button>
                <vs-button class="mt-2 mr-auto ml-1" size="small" icon-pack="feather" icon="icon-copy" v-if="tag"
                           v-clipboard:copy="tag"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">
                  {{$t('Copy Tag')}}
                </vs-button>
              </div>
            </div>
          </vs-tab>
          <!-- End Networks -->
        </vs-tabs>
      </div>
    </div>

    <form autocomplete="off" v-on:submit.prevent="submitFormDeposit()" v-if="coin.network.length > 0">
      <div class="lg:w-3/5 mx-auto">
        <p>
          {{$t('After deposit, you must fill out the form below to increase your balance.')}}
        </p>
        <vs-divider/>

        <div class="vx-row mb-8">
          <div class="vx-col w-full  mb-8">
            <vs-input class="w-full" icon-pack="feather" size="large" icon-no-border icon="icon-slack" :label="$t('Transaction ID (Txid)')" v-model="txid"
                      v-validate="'required'" :class="errors.has('txid') && depositSubmit ? 'border-danger':'' " name="txid"/>
          </div>

          <!--
          <div class="vx-col w-full">
            <vs-input type="file" class="w-full" icon-pack="feather" size="large" icon-no-border icon="icon-upload" :label="$t('Photo Receipt of deposit from the wallet of origin(optional)')"
                      v-model="file" :descriptionText="$t('Optional and to speed up transaction confirmation time')"
                      data-vv-as="file" :class="errors.has('file') && depositSubmit ? 'border-danger':''" name="file" id="file" ref="file" accept="image/*,.doc,.docx,.pdf"/>
            <span class="text-danger text-sm" v-show="errors.has('file') && this.depositSubmit">{{ errors.first('file') }}</span>
          </div>
          -->
        </div>

        <transition name="slide">
          <div class="w-full flex px-3" v-if="uploadPercentage > 0 && file">
            <p class="mr-3 text-center">{{uploadPercentage}}%</p>
            <vs-progress class="mt-1" :height="12" :percent="uploadPercentage" color="success"></vs-progress>
          </div>
        </transition>

        <div class="vx-row">
          <div class="vx-col w-full flex">
            <vs-button class="lg:mr-3 lg:mx-0 mx-auto mb-2" icon-pack="feather" icon="icon-check" :disabled="isLoading"
                       :id="'button-deposit-'+ coin.name" @click.prevent="submitFormDeposit">
              {{$t('Submit information')}}
            </vs-button>
            <vs-button color="dark" type="border" class="mb-2 hidden lg:inline-block" :to="'/wallets'">بازگشت</vs-button>
          </div>
        </div>
      </div>
    </form>

    <vs-divider/>

    <div class="mt-5 flex flex-wrap">
      <p class="mt-3">
        {{$t('Watch the tutorial video in this section.')}}
      </p>
      <vs-button color="warning" :href="videoLearn.diposit" target="_blank" class="mx-2" type="border"  icon-pack="feather" icon="icon-play">فیلم آموزش</vs-button>
    </div>

    <vs-popup title="Qr Code" class="popup-img" :active.sync="popupImage">
      <img class="responsive" :src="popupImgaeSrc">
    </vs-popup>

  </div>
</template>
<i18n locale="fa">
{
  "Transaction ID (Txid)":"لینک تراکنش (Txid)"
  ,"Photo Receipt of deposit from the wallet of origin(optional)":"عکس رسید واریز از کیف پول مبدا (اختیاری)"
  ,"Optional and to speed up transaction confirmation time":"اختیاری و جهت سرعت بخشیدن به زمان تایید تراکنش"
  ,"Copy َAddress":"کپی آدرس"
  ,"Copy Tag":"کپی تگ"
  ,"To deposit to a usable wallet, use the following wallet address. After depositing the effect, register the transaction in the box below within two hours of Txid.":
      "جهت واریز به کیف پول میتوانید از آدرس والت زیر استفاده نمایید. بعد از واریز کردن حداکثر تا دو ساعت Txid تراکنش را در کادر زیر ثبت کنید."
  ,"After deposit, you must fill out the form below to increase your balance.":"بعد از واریز میبایست فرم زیر را تکمیل نمایید تا موجودی شما افزایش یابد."
  ,"The deposit is temporarily closed":"واریز به این شبکه موقتاً غیرفعال است."
  ,"There is no possibility of deposit and withdrawal in increasing and decreasing currencies!":"در ارزهای افزایشی و کاهشی امکان واریز و برداشت وجود ندارد!"
}
</i18n>

<script>
    import axios from "../../../http/axios";

    export default {
      props: ['coin'],
      name: "Deposit",
      data () {
        return {
          isLoading:false,
          activeTab: null,
          depositSubmit:false,
          txid:'',
          file:null,
          uploadPercentage:0,
          popupImage:false,
          popupImgaeSrc:'',
        }
      },
      watch:{

      },
      methods:{
        submitFormDeposit(){
          this.$validator.validateAll().then(result => {
            if (result) {
              this.isLoading = true;
              this.$vs.loading({
                container: '#button-deposit-'+this.coin.name,
                scale: 0.65
              })

              const bodyFormData = new FormData();
              bodyFormData.append('txid', this.txid)
              /*
              var file = document.getElementById('file').files[0];
              if(file)
                bodyFormData.append('file', file)
               */

              const self = this
              axios.post('/wallets/'+this.coin.name+'/deposit', bodyFormData,{
                onUploadProgress: function( progressEvent ) {
                  this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                }.bind(this)
              })
              .then(function (response) {
                if (response.data.status == true) {
                  self.$swal({
                    icon: 'success',
                    title: self.$t('Success'),
                    text: response.data.msg
                  })
                  self.$emit('refreshData')
                  self.txid = '';
                  self.file = '';
                  self.$refs.file.reset();
                  self.depositSubmit = false;
                } else {
                  self.$vs.notify({title: self.$t('Error'), text: response.data.msg, iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger',time:6000})
                }
                self.uploadPercentage = 0;
                self.$vs.loading.close('#button-deposit-'+self.coin.name+' > .con-vs-loading'); self.isLoading = false;
              })
              .catch(function (error) {
                self.handelerErrorApi(error);
                self.uploadPercentage = 0;
                self.$vs.loading.close('#button-deposit-'+self.coin.name+' > .con-vs-loading'); self.isLoading = false;
              })
            }else {
              this.depositSubmit = true
            }
          })

        }
      },
      created() {
        this.activeTab = this.coin.network.findIndex(o => o.is_default ===true);

      },
      mounted() {

      }
    }
</script>

<style lang="scss">
#deposit_form_crypto{
  .vs-tabs--content {
    padding: 5px 5px !important;
  }
}

</style>
